import React, { useMemo } from 'react';
import { Breakpoint } from '../../BaseComponents/ThemeProvider/AvenyTheme';
import {
  useBreakpointContext,
  IBreakpointContext,
  BreakpointContextProvider,
} from './BreakpointContextUtils';

export const LocalBreakpointContextProvider: React.FC<
  React.PropsWithChildren<{
    breakpoint: Breakpoint;
  }>
> = props => {
  const parent = useBreakpointContext();
  const value: IBreakpointContext = useMemo(
    () => ({
      globalBreakPoint: parent.globalBreakPoint,
      coarsePointer: parent.coarsePointer,
      localBreakPoint: props.breakpoint,
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [props.breakpoint]
  );
  return (
    <BreakpointContextProvider value={value}>
      {props.children}
    </BreakpointContextProvider>
  );
};
